export const getDefaultState = () => {
  return {
    requestsPending: 0
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  loading: function(state) {
    return state.requestsPending > 0;
  }
};

// actions
const actions = {
  spinnerStart({ commit }) {
    commit("requestStart");
  }
};

// mutations
const mutations = {
  requestStart(state) {
    state.requestsPending++;
  },
  requestStop(state) {
    if (state.requestsPending > 0) state.requestsPending--;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
